import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MaterializeAction, toast } from 'angular2-materialize';
import { Subscription } from 'rxjs';
import { NgTable } from '../../coms';
import { ActivityId, ActivityService } from '../../services/activity.service';
import { EmployeeId, EmployeeService } from '../../services/employee.service';
import { NewPrompterReportService, NewPrompterReport, NewPrompterReportEmployee } from '../../services/new-prompter-report.service';
import { ProductionOrderId, ProductionOrderService } from '../../services/production-order.service';
import { ShipId, ShipService } from '../../services/ship.service';
import { Utils } from '../../util';

@Component({
  selector: 'app-update-new-prompter-report',
  templateUrl: './update-new-prompter-report.component.html',
  styleUrls: ['./update-new-prompter-report.component.css']
})
export class UpdateNewPrompterReportComponent implements OnInit, OnDestroy {

  id: string;
  reportEmployees: NewPrompterReportEmployee[]  = [];

  subs: Subscription[] = [];

  form: FormGroup;
  reportEmployee: NewPrompterReportEmployee = {
    id: '',
    name: '',
    shipId: '',
    shipName: '',
    activityId: '',
    activityName: '',
    time: '',
  };

  pickadateParams = Utils.pickadateParams();
  pickatimeParams = Utils.pickatimeParams();

  constructor(
    private service: NewPrompterReportService,
    private employeeService: EmployeeService,
    private odpService: ProductionOrderService,
    private shipService: ShipService,
    private activityService: ActivityService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

    let sub = this.service.getNewPrompterReport(this.id).subscribe(report => {
      sub.unsubscribe();
      this.form.patchValue(report);
      this.selectedIds[0] = report.employeeId;
      this.selectedIds[1] = report.odpId;
      this.reportEmployees = report.employees;
      this.reportEmployee.time = report.time;
    });

    this.subs[0] = this.employeeService.getEmployees().subscribe(employees => {
      this.employees = {};
      this.rowsRead[0] = this.rowsRead[2] = employees.map(employee => {
        employee.id = employee.id$;
        employee.name = `${employee.name} ${employee.lastName}`;
        this.employees[employee.id] = employee;
        return employee;
      });
    });

    this.subs[1] = this.odpService.getProductionOrders().subscribe(odps => {
      this.odps = {};
      this.rowsRead[1] = odps.map(odp => {
        this.odps[odp.id] = odp;
        return odp;
      });
    });

    this.subs[2] = this.shipService.getShips().subscribe(ships => {
      this.ships = {};
      this.rowsRead[3] = ships.map(ship => {
        ship.supervisor = ship.supervisorObj ? `${ship.supervisorObj.name} ${ship.supervisorObj.lastName}` : '';
        this.ships[ship.id] = ship;
        return ship;
      });
    });

    this.subs[3] = this.activityService.getActivities().subscribe(activitys => {
      this.activitys = {};
      this.rowsRead[4] = activitys.map(activity => {
        activity.appliesPrVnta = activity.appliesPrVnta ? 'Sí' : 'No';
        activity.appliesOdP = activity.appliesOdP ? 'Sí' : 'No';
        this.activitys[activity.id] = activity;
        return activity;
      });
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
    });
  }
  ngOnDestroy(){
    for(let sub of this.subs) sub.unsubscribe();
  }

  async onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let newPrompterReport: Partial<NewPrompterReport> = {
      employeeId: this.selectedIds[0],
      employeeName: this.employees[this.selectedIds[0]].name,
      odpId: this.selectedIds[1],
      odpName: this.odps[this.selectedIds[1]].name,
      date: value.date,
      time: value.time,
      employees: this.reportEmployees,
    };

    await this.service.updateNewPrompterReport(this.id, newPrompterReport);
    this.service.windowReplace.view(this.id);
  }
  onCancel(){
    this.service.windowReplace.read();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////REPORT EMPLOYEES 
  touchReportEmployee(){
    this.reportEmployee.id = this.selectedIds[2];
    this.reportEmployee.name = (this.employees[this.selectedIds[2]] || {name: ''}).name;
    this.reportEmployee.shipId = this.selectedIds[3];
    this.reportEmployee.shipName = (this.ships[this.selectedIds[3]] || {name: ''}).name;
    this.reportEmployee.activityId = this.selectedIds[4];
    this.reportEmployee.activityName = (this.activitys[this.selectedIds[4]] || {name: ''}).name;
    for(let key in this.reportEmployee) if(!this.reportEmployee[key]) return toast('Llene todos los datos para añadir.', 2000);
    this.reportEmployees.push({...this.reportEmployee});
    this.selectedIds[2] = '';
  }
  removeReportEmployee(index: number){
    this.reportEmployees.splice(index, 1);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  readTables: NgTable[] = [];
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    console.log(index);
    this.currentReadIndex = index;
    this.readTables[index] = new NgTable({columns: this.columnsRead[index], data: this.rowsRead[index], itemsPerPage: 5, onCellClick: this.selectRead.bind(this)});
  
    //this.onChangeTable(this.config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = data.row.id;
  }
  unselectRead(){
    this.closeModalRead();
    this.selectedIds[this.currentReadIndex] = '';
  }

  selectedIds: string[] = [''];
  employees: {[id: string]: EmployeeId} = {};
  odps: {[id: string]: ProductionOrderId} = {};
  ships: {[id: string]: ShipId} = {};
  activitys: {[id: string]: ActivityId} = {};

  get readValid(){ return !!this.employees[this.selectedIds[0]] && !!this.odps[this.selectedIds[1]] };
  currentReadIndex: number;
  rowsRead = [[], [], [], [], []];
  columnsRead = [
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//odp
      { title: 'Folio', name: 'name', sort: 'desc' },
      { title: 'Compromiso de entrega', name: 'deliveryDate' },
      { title: 'Cantidad', name: 'quantity' },
      { title: 'Estatus', name: 'status' }
    ],
    [//employee
      { title: 'Nombre', name: 'name' },
      { title: 'Folio', name: 'internalKey', sort: 'asc' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [//ship
      {title: '#', name: 'name',sort: 'asc'},
      {title: 'Descripción', name: 'description'},
      {title: 'Supervisor', name: 'supervisor'},
    ],
    [//activity
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Prod', name: 'appliesPrVnta'},
      { title: 'OdP', name: 'appliesOdP'},
    ]
  ];

}
